import { Component, Input, ViewEncapsulation } from '@angular/core';

import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'ui-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgStyle, NzSpinModule, NzIconModule],
})
export class UILoading {
  @Input() size = '24px'; // Default size
  @Input() text?: string;
  @Input() icon = 'loading';
  @Input() loading?: boolean = true;
}
